import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React, { useContext, useCallback, useMemo, createContext } from 'react';

/* istanbul ignore file */

var LOCALE_TEXT = {
  'common.add_to_basket': {
    'en-GB': 'Add to Basket',
    'nl-NL': 'In winkelmandje'
  },
  'common.сurrent': {
    'en-GB': 'Current: ',
    'nl-NL': 'Huidige: '
  },
  'common.сompleted': {
    'en-GB': 'Completed: ',
    'nl-NL': 'Voltooid: '
  },
  'common.loading': {
    'en-GB': 'Loading',
    'nl-NL': 'Bezig met laden'
  },
  'common.total_reviews': {
    'en-GB': 'Total reviews',
    'nl-NL': 'Totaal aantal beoordelingen'
  },
  'common.close': {
    'en-GB': 'Close',
    'nl-NL': 'Sluiten'
  },
  'common.side-modal.back.label': {
    'en-GB': 'Go back',
    'nl-NL': 'Terug'
  },
  'common.side-modal.close.label': {
    'en-GB': 'Close',
    'nl-NL': 'Sluiten'
  },
  'carousel.description': {
    'en-GB': 'Carousel',
    'nl-NL': 'Carrousel'
  },
  'carousel.skip_link.default': {
    'en-GB': 'Skip carousel',
    'nl-NL': 'Carrousel overslaan'
  },
  'carousel.skip_link.with_label': {
    'en-GB': function enGB(label) {
      return "Skip ".concat(label);
    },
    'nl-NL': function nlNL(label) {
      return "".concat(label, " overslaan");
    }
  },
  'carousel.controls': {
    'en-GB': 'Carousel controls',
    'nl-NL': 'Carrouselbediening'
  },
  'carousel.previous_slide': {
    'en-GB': 'Go to previous slide',
    'nl-NL': 'Ga naar vorige dia'
  },
  'carousel.next_slide': {
    'en-GB': 'Go to next slide',
    'nl-NL': 'Ga naar volgende dia'
  },
  'code-input.label': {
    'en-GB': function enGB(label, index, length) {
      return "".concat(label, ": Character ").concat(index + 1, " of ").concat(length);
    },
    'nl-NL': function nlNL(label, index, length) {
      return "".concat(label, ": Karakter ").concat(index + 1, " van ").concat(length);
    }
  },
  'icon_button.notification_label': {
    'en-GB': ', new notification',
    'nl-NL': ', nieuwe melding'
  },
  'image_carousel.previous_image': {
    'en-GB': 'Previous image',
    'nl-NL': 'Vorige afbeelding'
  },
  'image_carousel.next_image': {
    'en-GB': 'Next image',
    'nl-NL': 'Volgende afbeelding'
  },
  'image_carousel.show_image': {
    'en-GB': function enGB(key) {
      return "Show image ".concat(key + 1);
    },
    'nl-NL': function nlNL(key) {
      return "Afbeelding ".concat(key + 1, " weergeven");
    }
  },
  'rating.rated': {
    'en-GB': function enGB(rating) {
      return "Rated ".concat(Number(rating).toLocaleString('en-GB'), " out of 5");
    },
    'nl-NL': function nlNL(rating) {
      return "Beoordeeld ".concat(Number(rating).toLocaleString('nl-NL'), " van 5");
    }
  },
  'password_input.hide_password': {
    'en-GB': 'Your password is visible. Hide password',
    'nl-NL': 'Uw wachtwoord is zichtbaar. Verberg wachtwoord'
  },
  'password_input.show_password': {
    'en-GB': 'Your password is not visible. Show password',
    'nl-NL': 'Uw wachtwoord is niet zichtbaar. Laat wachtwoord zien'
  },
  'quantity_input.subtract_item': {
    'en-GB': 'Subtract item',
    'nl-NL': 'Artikel aftrekken'
  },
  'quantity_input.add_item': {
    'en-GB': 'Add item',
    'nl-NL': 'Artikel toevoegen'
  },
  'tabs.tab_list.default_aria_label': {
    'en-GB': 'Tab list',
    'nl-NL': 'Tabbladlijst'
  },
  'tabs.badge.count': {
    'en-GB': function enGB(count) {
      return "(".concat(count, " items)");
    },
    'nl-NL': function nlNL(count) {
      return "(".concat(count, " artikelen)");
    }
  },
  'text_area.characters_limit': {
    'en-GB': function enGB(charactersUsed, maxCharacters) {
      return "".concat(charactersUsed, " out of ").concat(maxCharacters, " characters used");
    },
    'nl-NL': function nlNL(charactersUsed, maxCharacters) {
      return "".concat(charactersUsed, " van ").concat(maxCharacters, " tekens gebruikt");
    }
  },
  our_pick: {
    'en-GB': 'Our Pick',
    'nl-NL': 'Onze keus'
  },
  'skeleton_box.loading_indicator_box': {
    'en-GB': 'Loading indicator box',
    'nl-NL': 'Bezig met laden van vakindicator'
  },
  'progress-indicator-step': {
    'en-GB': 'Step',
    'nl-NL': 'Stap'
  },
  'progress-indicator-of': {
    'en-GB': 'of',
    'nl-NL': 'van'
  },
  'progress-indicator-incomplete': {
    'en-GB': 'incomplete',
    'nl-NL': 'onvolledig'
  },
  'progress-indicator-completed': {
    'en-GB': 'completed',
    'nl-NL': 'voltooid'
  },
  'progress-indicator-active': {
    'en-GB': 'active',
    'nl-NL': 'actief'
  }
};

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ACCENTED_MAP = {
  a: 'ȧ',
  A: 'Ȧ',
  b: 'ƀ',
  B: 'Ɓ',
  c: 'ƈ',
  C: 'Ƈ',
  d: 'ḓ',
  D: 'Ḓ',
  e: 'ḗ',
  E: 'Ḗ',
  f: 'ƒ',
  F: 'Ƒ',
  g: 'ɠ',
  G: 'Ɠ',
  h: 'ħ',
  H: 'Ħ',
  i: 'ī',
  I: 'Ī',
  j: 'ĵ',
  J: 'Ĵ',
  k: 'ķ',
  K: 'Ķ',
  l: 'ŀ',
  L: 'Ŀ',
  m: 'ḿ',
  M: 'Ḿ',
  n: 'ƞ',
  N: 'Ƞ',
  o: 'ǿ',
  O: 'Ǿ',
  p: 'ƥ',
  P: 'Ƥ',
  q: 'ɋ',
  Q: 'Ɋ',
  r: 'ř',
  R: 'Ř',
  s: 'ş',
  S: 'Ş',
  t: 'ŧ',
  T: 'Ŧ',
  v: 'ṽ',
  V: 'Ṽ',
  u: 'ŭ',
  U: 'Ŭ',
  w: 'ẇ',
  W: 'Ẇ',
  x: 'ẋ',
  X: 'Ẋ',
  y: 'ẏ',
  Y: 'Ẏ',
  z: 'ẑ',
  Z: 'Ẑ'
};
var pseudoLocalizeString = function pseudoLocalizeString(str, strategy) {
  var opts = _objectSpread$1({
    prefix: '',
    postfix: '',
    map: ACCENTED_MAP,
    elongate: true
  }, strategy);
  var pseudoLocalizedText = '';
  // eslint-disable-next-line no-restricted-syntax
  var _iterator = _createForOfIteratorHelper(str),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var character = _step.value;
      if (opts.map[character]) {
        var cl = character.toLowerCase();
        if (opts.elongate && (cl === 'a' || cl === 'e' || cl === 'o' || cl === 'u')) {
          pseudoLocalizedText += opts.map[character] + opts.map[character];
        } else pseudoLocalizedText += opts.map[character];
      } else pseudoLocalizedText += character;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (pseudoLocalizedText.startsWith(opts.prefix) && pseudoLocalizedText.endsWith(opts.postfix)) {
    return pseudoLocalizedText;
  }
  return opts.prefix + pseudoLocalizedText + opts.postfix;
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT_LOCALE = 'en-GB';
var LocalisationContext = /*#__PURE__*/createContext({
  locale: DEFAULT_LOCALE,
  localeTextDictionary: LOCALE_TEXT
});
var useLocale = function useLocale(region) {
  switch (region) {
    case 'uk':
    case 'ie':
      return 'en-GB';
    case 'us':
      return 'en-US';
    case 'au':
      return 'en-AU';
    case 'nl':
      return 'nl-NL';
    case 'pseudo':
      return 'en-psaccent';
    default:
      return 'en-GB';
  }
};
var useLocaleText = function useLocaleText() {
  var _useContext = useContext(LocalisationContext),
    locale = _useContext.locale,
    localeTextDictionary = _useContext.localeTextDictionary;
  return useCallback(function (key) {
    var match = localeTextDictionary[key];
    var getText = match[locale] || match[DEFAULT_LOCALE];
    for (var _len = arguments.length, context = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      context[_key - 1] = arguments[_key];
    }
    var value = typeof getText === 'function' ? getText.apply(void 0, context) : getText;
    if (locale === 'en-psaccent') {
      return pseudoLocalizeString(value, {
        prefix: '[',
        postfix: ']'
      });
    }
    return value;
  }, [locale, localeTextDictionary]);
};
var LocaleTextProvider = function LocaleTextProvider(_ref) {
  var region = _ref.region,
    locale = _ref.locale,
    children = _ref.children,
    dictionary = _ref.dictionary;
  var localeByRegion = useLocale(region);
  var selectedLocale = locale || localeByRegion;
  var context = useMemo(function () {
    return {
      locale: selectedLocale,
      localeTextDictionary: _objectSpread(_objectSpread({}, LOCALE_TEXT), dictionary)
    };
  }, [selectedLocale, dictionary]);
  return /*#__PURE__*/React.createElement(LocalisationContext.Provider, {
    value: context
  }, children);
};

/* istanbul ignore file */
var STORYBOOK_LOCALE_TEXT = {
  'component.button.default': {
    'en-GB': 'Default button',
    'nl-NL': 'Primaire knop'
  },
  'component.button.full-width': {
    'en-GB': 'Full width button',
    'nl-NL': 'Volledige breedte knop'
  },
  'component.button.inactive': {
    'en-GB': 'Inactive button',
    'nl-NL': 'Inactieve knop'
  },
  'component.button.loading': {
    'en-GB': 'Loading',
    'nl-NL': 'Laden'
  },
  'component.button.link': {
    'en-GB': 'Link button',
    'nl-NL': 'Link knop'
  },
  'component.tertiary-button.pre-inline': {
    'en-GB': 'This is an',
    'nl-NL': 'Dit is een'
  },
  'component.tertiary-button.inline': {
    'en-GB': 'inline tertiary button',
    'nl-NL': 'inline tertiaire knop'
  },
  'component.tertiary-button.post-inline': {
    'en-GB': 'example.',
    'nl-NL': 'voorbeeld.'
  },
  'component.alert.success.heading': {
    'en-GB': "That's great, you're good to go!",
    'nl-NL': 'Dat is geweldig, je bent klaar om te gaan!'
  },
  'component.alert.success.text': {
    'en-GB': 'You can now close this.',
    'nl-NL': 'U kunt dit nu afsluiten.'
  },
  'component.alert.warning.heading': {
    'en-GB': 'You cannot cancel this operation.',
    'nl-NL': 'U kunt deze operatie niet annuleren.'
  },
  'component.alert.error.heading': {
    'en-GB': 'There is a problem with your connection.',
    'nl-NL': 'Er is een probleem met uw verbinding.'
  },
  'component.alert.error.text': {
    'en-GB': 'Please try again.',
    'nl-NL': 'Probeer het opnieuw.'
  },
  'component.alert.info.heading': {
    'en-GB': 'An informative heading.',
    'nl-NL': 'Een informatieve rubriek.'
  },
  'component.alert.custom-icon.heading': {
    'en-GB': 'Your card is on its way!',
    'nl-NL': 'Je kaart is onderweg!'
  },
  'component.alert.closeable.heading': {
    'en-GB': "Pass a callback and we'll give you a close icon.",
    'nl-NL': 'Geef een callback door en we geven je een sluitpictogram.'
  },
  'component.alert.with-cta.heading': {
    'en-GB': 'You now have two options...',
    'nl-NL': 'Je hebt nu twee opties...'
  },
  'component.alert.with-cta.cta1': {
    'en-GB': 'Discard Changes',
    'nl-NL': 'Weggooien Wijzigingen'
  },
  'component.alert.with-cta.cta2': {
    'en-GB': 'Continue',
    'nl-NL': 'Ga verder'
  },
  'component.banner.start': {
    'en-GB': 'Start',
    'nl-NL': 'Start'
  },
  'component.banner.apply': {
    'en-GB': 'Apply',
    'nl-NL': 'Toepassen'
  },
  'component.banner.collage-designer': {
    'en-GB': 'Be the first to try our brand-new, fully-editable collage designer!',
    'nl-NL': 'Wees de eerste die onze gloednieuwe, volledig bewerkbare collage-ontwerper uitprobeert!'
  },
  'component.banner.heading-buy2': {
    'en-GB': 'Buy 2 Cards, Save 30%',
    'nl-NL': 'Koop 2 kaarten, bespaar 30%'
  },
  'component.banner.body-buy2': {
    'en-GB': 'Use code BUY2GET30 at checkout to save 30% on those special occasions.',
    'nl-NL': 'Gebruik de code BUY2GET30 bij het afrekenen om 30% te besparen op die speciale gelegenheden.'
  },
  'component.banner.same-day': {
    'en-GB': 'Order your card by 9pm for same-day dispatch. Order gifts by 9pm for next day delivery.',
    'nl-NL': 'Bestel uw kaart vóór 21:00 uur voor verzending op dezelfde dag. Bestel cadeaus vóór 21:00 uur voor levering de volgende dag.'
  },
  'component.banner.40-percent': {
    'en-GB': "You've got 40% off gifts!",
    'nl-NL': 'Je hebt 40% korting op cadeaus!'
  },
  'component.banner.apply-code': {
    'en-GB': 'Tap to apply the code to basket.',
    'nl-NL': 'Tik om de code toe te passen op de winkelmand.'
  },
  'component.carousel.longer-text': {
    'en-GB': 'Slide with longer content than the rest, which will cause the slide item to grow',
    'nl-NL': 'Dia met langere inhoud dan de rest, waardoor het dia-item groeien'
  },
  'component.iconlist.success': {
    'en-GB': 'Success',
    'nl-NL': 'Succes'
  },
  'component.iconlist.warning': {
    'en-GB': 'Warning',
    'nl-NL': 'Waarschuwing'
  },
  'component.iconlist.error': {
    'en-GB': 'Error',
    'nl-NL': 'Fout'
  },
  'component.iconlist.heading': {
    'en-GB': 'Heading',
    'nl-NL': 'Titel'
  },
  'component.iconlist.icon-item': {
    'en-GB': 'An item with an icon',
    'nl-NL': 'Een item met een pictogram'
  },
  'component.iconlist.icon-item2': {
    'en-GB': 'A second item with an icon',
    'nl-NL': 'Een tweede item met een pictogram'
  },
  'component.iconlist.icon-item3': {
    'en-GB': 'A third item with an icon',
    'nl-NL': 'Een derde item met een pictogram'
  },
  'component.iconlist.icon-item-default-color': {
    'en-GB': 'An item with an icon (default colour)',
    'nl-NL': 'Een item met een pictogram (standaardkleur)'
  },
  'component.iconlist.icon-item-heading': {
    'en-GB': 'An item with a heading and icon',
    'nl-NL': 'Een item met een kop en pictogram'
  },
  'component.pill.default': {
    'en-GB': 'Default Pill',
    'nl-NL': 'Standaard Pill'
  },
  'component.pill.letterbox-friendly': {
    'en-GB': 'Letterbox Friendly',
    'nl-NL': 'Brievenbusvriendelijk'
  },
  'component.pill.favorite': {
    'en-GB': 'Moonpig Favourite',
    'nl-NL': 'Greetz Favoriet'
  },
  'component.pill.discount': {
    'en-GB': '£5 off',
    'nl-NL': '€5 korting'
  },
  'component.pill.vegan': {
    'en-GB': 'Vegan',
    'nl-NL': 'Veganistisch'
  },
  'component.pill.plus': {
    'en-GB': '50% off with MP+',
    'nl-NL': '50% korting met MP+'
  },
  'component.pill.sponsored': {
    'en-GB': 'Sponsored',
    'nl-NL': 'Samenwerking'
  },
  'component.rating.ratings': {
    'en-GB': 'Ratings',
    'nl-NL': 'Beoordelingen'
  },
  'component.rating.total-ratings': {
    'en-GB': 'Total Reviews',
    'nl-NL': 'Totaal Beoordelingen'
  },
  'component.strip': {
    'en-GB': 'Enjoy 3 for 2 on Cards - Use Code SEPT342 at Checkout',
    'nl-NL': 'Geniet van 3 voor 2 op kaarten - Gebruik code SEPT342 bij de kassa.'
  },
  'component.side-modal.heading': {
    'en-GB': 'How do you rate your website experience today?',
    'nl-NL': 'Hoe beoordeel je je ervaring met de website vandaag?'
  },
  'component.tabs.all': {
    'en-GB': 'All',
    'nl-NL': 'Alles'
  },
  'component.tabs.cards': {
    'en-GB': 'Cards',
    'nl-NL': 'Kaarten'
  },
  'component.tabs.gifts': {
    'en-GB': 'Gifts',
    'nl-NL': 'Cadeaus'
  },
  'component.tabs.flowers': {
    'en-GB': 'Flowers',
    'nl-NL': 'Bloemen'
  },
  'component.tabs.flowers-plants': {
    'en-GB': 'Flowers & Plants',
    'nl-NL': 'Bloemen & planten'
  },
  'component.tabs.other-gifts': {
    'en-GB': 'Other gifts',
    'nl-NL': 'Overige cadeaus'
  },
  'component.heart-toggle.label.active': {
    'en-GB': 'Remove this product from favourites',
    'nl-NL': 'Verwijder dit product uit favorieten'
  },
  'component.heart-toggle.label.inactive': {
    'en-GB': 'Add this product to favourites',
    'nl-NL': 'Voeg dit product toe aan favorieten'
  },
  'component.info-strip.title': {
    'en-GB': 'Order Your Personalised Card by 7:30pm (Mon – Fri) to Catch Today’s Post',
    'nl-NL': 'Bestel uw gepersonaliseerde kaart vóór 19:30 uur (ma-vr) om deze vandaag nog te verzenden'
  },
  'component.chip.label': {
    'en-GB': 'Chip',
    'nl-NL': 'Spaander'
  },
  'forms.form-control-label.with-checkbox.label': {
    'en-GB': 'Checkbox',
    'nl-NL': 'Aankruisvakje'
  },
  'forms.form-control-label.with-radio.label': {
    'en-GB': 'Radio button',
    'nl-NL': 'Radio knop'
  },
  'forms.form-control-label.with-toggle.label': {
    'en-GB': 'Toggle button',
    'nl-NL': 'Schakelaar knop'
  },
  'forms.form-control-label.disabled.label': {
    'en-GB': 'Disabled',
    'nl-NL': 'Uitgeschakeld'
  },
  'forms.helper-text.label': {
    'en-GB': 'Helper text',
    'nl-NL': 'Hulptekst'
  },
  'forms.helper-text.live-label': {
    'en-GB': 'Assertive Helper text',
    'nl-NL': 'Assertieve Helper-tekst'
  },
  'forms.helper-text.hide': {
    'en-GB': 'Hide',
    'nl-NL': 'verbergen'
  },
  'forms.helper-text.show': {
    'en-GB': 'Show',
    'nl-NL': 'Tonen'
  },
  'forms.label.label': {
    'en-GB': 'Email',
    'nl-NL': 'E-mailen'
  },
  'forms.descriptor-text.label': {
    'en-GB': 'Please enter your name below for personalized communication. Your privacy is important to us and we will only use your name for this purpose.',
    'nl-NL': 'Voer hieronder uw naam in voor gepersonaliseerde communicatie. Uw privacy is belangrijk voor ons en we zullen uw naam alleen hiervoor gebruiken.'
  },
  'forms.password.label': {
    'en-GB': 'Password',
    'nl-NL': 'Wachtwoord'
  },
  'forms.password.error': {
    'en-GB': 'Invalid password',
    'nl-NL': 'Onjuist wachtwoord'
  },
  'forms.radio-group.gender': {
    'en-GB': 'Gender',
    'nl-NL': 'Geslacht'
  },
  'forms.radio-group.male': {
    'en-GB': 'Male',
    'nl-NL': 'Mannelijk'
  },
  'forms.radio-group.female': {
    'en-GB': 'Female',
    'nl-NL': 'Vrouwelijk'
  },
  'forms.radio-group.other': {
    'en-GB': 'Other',
    'nl-NL': 'Anders'
  },
  'forms.radio-group.disabled': {
    'en-GB': 'Disabled option',
    'nl-NL': 'Uitgeschakelde optie'
  },
  'forms.dropdown.label': {
    'en-GB': 'Select',
    'nl-NL': 'Selecteren'
  },
  'forms.dropdown.placeholder': {
    'en-GB': 'Please select',
    'nl-NL': 'Selecteer alstublieft'
  },
  'forms.dropdown.helper-text': {
    'en-GB': 'Please select an option',
    'nl-NL': 'Selecteer alstublieft een optie'
  },
  'forms.dropdown.option': {
    'en-GB': 'Option',
    'nl-NL': 'Optie'
  },
  'forms.text-area.label': {
    'en-GB': 'Your message',
    'nl-NL': 'Uw bericht'
  },
  'forms.text-area.descriptor': {
    'en-GB': 'Add your message below.',
    'nl-NL': 'Voeg hieronder je bericht toe.'
  },
  'forms.text-area.placeholder': {
    'en-GB': 'e.g. Happy Birthday, Cheers, Sam!',
    'nl-NL': 'bijv. Gelukkige verjaardag, Proost, Sam!'
  },
  'forms.text-area.helper-text': {
    'en-GB': 'Helper text',
    'nl-NL': 'Hulp tekst'
  },
  'forms.text-area.error-message': {
    'en-GB': 'Error helper text',
    'nl-NL': 'Foutmelding hulp tekst'
  },
  'forms.text-input.error-character-limit-reached': {
    'en-GB': 'Character limit reached',
    'nl-NL': 'Tekenlimiet bereikt'
  },
  'forms.text-input.label': {
    'en-GB': 'Email',
    'nl-NL': 'E-mail'
  },
  'forms.text-input.number-label': {
    'en-GB': 'Number',
    'nl-NL': 'Nummer'
  },
  'forms.text-input.placeholder': {
    'en-GB': 'e.g. me@example.com',
    'nl-NL': 'b.v. ik@voorbeeld.com'
  },
  'forms.text-input.descriptor': {
    'en-GB': 'Please enter your name below for personalized communication. Your privacy is important to us and we will only use your name for this purpose.',
    'nl-NL': 'Voer hieronder uw naam in voor gepersonaliseerde communicatie. Uw privacy is belangrijk voor ons en we zullen uw naam alleen hiervoor gebruiken.'
  },
  'forms.text-input.helper-text': {
    'en-GB': 'Helper text',
    'nl-NL': 'Hulptekst'
  },
  'forms.text-input.delivery-text': {
    'en-GB': 'Delivery Instructions',
    'nl-NL': 'Bezorginstructies'
  },
  'forms.text-input.search-text': {
    'en-GB': 'Search',
    'nl-NL': 'Zoeken'
  },
  'forms.text-input.mothers-day-text': {
    'en-GB': "e.g. Mother's Day",
    'nl-NL': 'bijv. Moederdag'
  },
  'forms.text-input.search-placeholder': {
    'en-GB': 'e.g. behind the planter',
    'nl-NL': 'bijv. achter de bloembak'
  },
  'forms.selector-group.delivery-options': {
    'en-GB': 'Delivery Options',
    'nl-NL': 'Bezorgopties'
  },
  'forms.free.delivery': {
    'en-GB': 'Free Delivery',
    'nl-NL': 'Gratis bezorging'
  },
  'forms.express.delivery': {
    'en-GB': 'Express Delivery',
    'nl-NL': 'Snelle bezorging'
  },
  'forms.warp.speed.delivery': {
    'en-GB': 'Warp Speed Delivery',
    'nl-NL': 'Ultrarapid bezorging'
  },
  'forms.portrait': {
    'en-GB': 'Portrait',
    'nl-NL': 'Portret'
  },
  'forms.landscape.card.with.icon': {
    'en-GB': 'Landscape Card (with icon)',
    'nl-NL': 'Liggende kaart (met pictogram)'
  },
  'forms.square.card': {
    'en-GB': 'Square Card',
    'nl-NL': 'Vierkante kaart'
  },
  'forms.a.perfect.square.card': {
    'en-GB': 'A perfect square card',
    'nl-NL': 'Een perfect vierkante kaart'
  },
  'forms.portrait.card.with.icon': {
    'en-GB': 'Portrait Card (with icon)',
    'nl-NL': 'Portretkaart (met pictogram)'
  },
  'forms.a.rectangle.card': {
    'en-GB': 'A rectangle card',
    'nl-NL': 'Een rechthoekige kaart'
  },
  'forms.portrait.card': {
    'en-GB': 'Portrait Card',
    'nl-NL': 'Portretkaart'
  },
  'forms.for.those.that.like.rectangles': {
    'en-GB': 'For those that like rectangles',
    'nl-NL': 'Voor degenen die van rechthoeken houden'
  },
  'forms.square.card.with.icon': {
    'en-GB': 'Square Card (with icon)',
    'nl-NL': 'Vierkante kaart (met pictogram)'
  },
  'forms.for.those.that.like.squares': {
    'en-GB': 'For those that like squares',
    'nl-NL': 'Voor degenen die van vierkanten houden'
  },
  'forms.expires': {
    'en-GB': 'Expires',
    'nl-NL': 'Verloopt'
  },
  'forms.expired': {
    'en-GB': 'Expired',
    'nl-NL': 'Verlopen'
  }
};

export { LOCALE_TEXT, LocaleTextProvider, STORYBOOK_LOCALE_TEXT, pseudoLocalizeString, useLocaleText };
